// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__B_IIK","ranges":"BmiRanges_ranges__2SdCh"};